import {
  NewsletterClientDriver,
  NewsletterSubscribeOptions,
} from "@made-people/grease-newsletter";
import { AxiosInstance } from "axios";
import { z } from "zod";

export interface MmEmarsysConfig {
  language: string;
  country: string;
  optinMethod: z.infer<typeof mmEmarsysOptinMethodEnum>;
}

const mmEmarsysOptinMethodEnum = z.enum([
  // the default
  "newsletter",

  // on checkout success page
  "checkout",

  // on account sign-up
  "club",

  // on the order tracking page
  "tracking",

  // in the footer
  "footer",
]);

const mmEmarsysNewsletterOptionsSchema = z.object({
  optinMethod: mmEmarsysOptinMethodEnum.optional(),
  phoneNumber: z.string().optional(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
});

export type MmEmarsysNewsletterOptions = z.infer<
  typeof mmEmarsysNewsletterOptionsSchema
>;

/**
 * This class implements Miss Mary's custom emarsys endpoint for subscribing
 * to the newsletter. That's why it's prefixed with 'Mm'.
 */
export class MmEmarsysNewsletterClient
  implements NewsletterClientDriver<MmEmarsysNewsletterOptions>
{
  constructor(
    private readonly client: AxiosInstance,
    private readonly config: MmEmarsysConfig,
  ) {}

  async subscribe(
    options: NewsletterSubscribeOptions<MmEmarsysNewsletterOptions>,
  ): Promise<void> {
    const { email, attributes } = options;
    const parsedData = mmEmarsysNewsletterOptionsSchema.safeParse(attributes);
    if (!parsedData.success) {
      throw new Error(
        `[MmEmarsysNewsletterClient]: Invalid input data for Emarsys newsletter, ${JSON.stringify(
          parsedData.error.errors,
        )}`,
      );
    }

    await this.client.put("/emarsys/subscribe", {
      email,
      language: this.config.language,
      country: this.config.country,
      ...parsedData.data,
      optinMethod: parsedData.data.optinMethod ?? this.config.optinMethod,
    });
  }

  async unsubscribe() //options: NewsletterUnsubscribeOptions<MmEmarsysNewsletterOptions>,
  : Promise<void> {
    throw new Error("Unsubscribe method not implemented");
  }
}
